var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ApolloClient } from 'apollo-client';
import { RestLink } from 'apollo-link-rest';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { setContext } from 'apollo-link-context';
import { onError } from 'apollo-link-error';
import { ApolloLink, Observable } from 'apollo-link';
import { withClientState } from 'apollo-link-state';
import Cookies from 'js-cookie';
import { mainApi } from './config';
import { initialState, localResolvers } from './gql/localData';
import { sessionLogin } from './auth/cognito/organizationApi';
var isDevStage = window.location.href.indexOf('localhost') !== -1 ||
    window.location.href.indexOf(':3000') !== -1 ||
    window.location.href.indexOf('tt-react-dev') !== -1 ||
    window.location.href.indexOf('tt-react-test') !== -1 ||
    window.location.href.indexOf('.dev.trainingtube.com') !== -1;
var mainApiUrl = mainApi(isDevStage);
var isLocalStage = window.location.href.indexOf('localhost') !== -1 || window.location.href.indexOf(':3000') !== -1;
var restLink = new RestLink({
    endpoints: {
        query: mainApiUrl.query,
        command: mainApiUrl.command,
        users: mainApiUrl.user,
    },
    typePatcher: {
        Topic: function (data) {
            if (data.comments != null) {
                data.comments = data.comments.map(function (comment) { return (__assign({ __typename: 'Comment' }, comment)); });
            }
            return data;
        },
        TrackStructure: function (data) {
            if (data.items) {
                data.items = data.items.map(function (item) { return (__assign({ __typename: 'TrackStructure' }, item)); });
            }
            return data;
        },
        /* … other nested type patchers … */
    },
    headers: {
        'Content-Type': 'application/json',
    },
});
var authRestLink = setContext(function () {
    var token = localStorage.getItem('token');
    var headers = {
        Accept: 'application/json',
        Authorization: "Bearer " + token,
    };
    return {
        headers: headers,
    };
});
var cache = new InMemoryCache();
var stateLink = withClientState({
    cache: cache,
    resolvers: localResolvers,
    defaults: initialState,
});
var errorLink = function (orgId, ssoUrl) {
    return onError(function (_a) {
        var networkError = _a.networkError, operation = _a.operation, forward = _a.forward;
        if (networkError &&
            networkError['statusCode'] === 401 &&
            window.location.pathname !== '/login' &&
            window.location.pathname !== '/forgot-password' &&
            window.location.pathname !== '/reset-password' &&
            window.location.pathname !== '/login-lp' &&
            window.location.pathname !== '/auto-login' &&
            window.location.pathname !== '/lp' &&
            window.location.pathname !== '/loginembed' &&
            window.location.pathname !== '/register') {
            // User access token has expired
            // refresh token through async request
            return new Observable(function (observer) {
                sessionLogin(ssoUrl)
                    .then(function (refreshResponse) {
                    operation.setContext(function () { return ({
                        headers: {
                            Accept: 'application/json',
                            authorization: "Bearer " + localStorage.getItem('token'),
                        },
                    }); });
                })
                    .then(function () {
                    var subscriber = {
                        next: observer.next.bind(observer),
                        error: observer.error.bind(observer),
                        complete: observer.complete.bind(observer),
                    };
                    // Retry last failed request
                    forward(operation).subscribe(subscriber);
                })
                    .catch(function (error) {
                    // No refresh or client token available, we force user to login
                    Cookies.set('prevLocation', window.location.pathname, { expires: 0.1 });
                    if (window.location.pathname.startsWith('/embed/') || window.location.pathname.startsWith('/sharing/')) {
                        return (window.location.href = '/loginembed?redirect=' + window.location.href);
                    }
                    if (isLocalStage) {
                        return (window.location.href = '/login?redirect=' + window.location.href);
                    }
                    var devParam = isDevStage ? '&isDev=true' : '';
                    return (window.location.href =
                        'https://www.trainingtube.com/login?redirectTo=' +
                            window.location.pathname +
                            '&commingFrom=' +
                            orgId +
                            devParam);
                });
            });
        }
    });
};
var client = function (orgId, ssoUrl) {
    return new ApolloClient({
        link: ApolloLink.from([errorLink(orgId, ssoUrl), authRestLink, restLink, stateLink]),
        cache: cache,
    });
};
export default client;



//////////////////
// WEBPACK FOOTER
// ./src/apolloConfig.ts
// module id = 1498
// module chunks = 81